
const imgUrlList = require('./jdlib_HuiXiao_ZhanWaiQuan');
function getImagUrL(key) {
    if (imgUrlList[key + '@2x']) {
        return imgUrlList[key + '@2x'];
    } else if (imgUrlList[key]) {
        return imgUrlList[key];
    }
}
export default {
    activeBg: getImagUrL('bg_active'),
    bg: getImagUrL('bg'),
    info: getImagUrL('right'),
    closeImg: getImagUrL('close')
};
